import actions from '@/modules/today/store/actions'
import getters from '@/modules/today/store/getters'
import mutations from '@/modules/today/store/mutations'

export default {
  state: () => ({}),
  actions: actions,
  getters: getters,
  mutations: mutations
}
